interface HeaderRoute {
    id: string
    title: string
    route: string
    position: 'left' | 'right'
    hidden?: boolean
}

export const publicHeaderData: HeaderRoute[] = [
    {
        id: 'shops',
        title: 'header.publicHeader.nav.browseShops',
        route: '/shops',
        position: 'left',
    },
    {
        id: 'home',
        title: 'header.publicHeader.nav.home',
        route: '/',
        position: 'right',
    },
    // {
    //     id: 'jobs',
    //     title: 'Jobs',
    //     route: '/jobs',
    //     position: 'left',
    //     hidden: true,
    // },

    {
        id: 'pricing',
        title: 'header.publicHeader.nav.pricing',
        route: '/pricing',
        position: 'right',
    },
    {
        id: 'download',
        title: 'header.publicHeader.nav.downloadApp',
        route: '/download-app',
        position: 'right',
    },
]
